import { Component } from "@angular/core";
import { RenderReactDirective } from "shared/angular-react";
import { CallEndedOrNotAllowedPage } from "live-lesson/shared/feature-call-ui-react";

@Component({
    selector: "pcp-live-lesson-call-expired-or-invalid-page",
    template: `
        <div renderReact [reactComponent]="ReactComponent"></div>
    `,
    imports: [
        RenderReactDirective,
    ],
})
export class CallExpiredOrInvalidPageComponent {
    protected readonly ReactComponent = CallEndedOrNotAllowedPage;
}
